/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createWorkspace = /* GraphQL */ `
  mutation CreateWorkspace(
    $input: CreateWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    createWorkspace(input: $input, condition: $condition) {
      id
      workspaceGroups
      name
      logoLink
      workspacetoken
      networks {
        items {
          workspaceGroups
          networkOrgName
          orgId
          api_key
          api_secret
          id
          createdAt
          updatedAt
          workspaceNetworksId
          networkTypeNetworksId
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      objectProperties {
        items {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectPropertiesId
          __typename
        }
        nextToken
        __typename
      }
      objectTypes {
        items {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectTypesId
          __typename
        }
        nextToken
        __typename
      }
      sites {
        items {
          workspaceGroups
          name
          metadata
          address
          zip_code
          city
          subRegion
          region
          country
          AWSLocationLabel
          AWSLongLat
          properties
          id
          createdAt
          updatedAt
          workspaceSitesId
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          workspaceGroups
          name
          layout
          showInNavigation
          icon
          id
          createdAt
          updatedAt
          workspaceDashboardsId
          dashboardGroupDashboardsId
          dashboardDashboardGroupId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWorkspace = /* GraphQL */ `
  mutation UpdateWorkspace(
    $input: UpdateWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    updateWorkspace(input: $input, condition: $condition) {
      id
      workspaceGroups
      name
      logoLink
      workspacetoken
      networks {
        items {
          workspaceGroups
          networkOrgName
          orgId
          api_key
          api_secret
          id
          createdAt
          updatedAt
          workspaceNetworksId
          networkTypeNetworksId
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      objectProperties {
        items {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectPropertiesId
          __typename
        }
        nextToken
        __typename
      }
      objectTypes {
        items {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectTypesId
          __typename
        }
        nextToken
        __typename
      }
      sites {
        items {
          workspaceGroups
          name
          metadata
          address
          zip_code
          city
          subRegion
          region
          country
          AWSLocationLabel
          AWSLongLat
          properties
          id
          createdAt
          updatedAt
          workspaceSitesId
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          workspaceGroups
          name
          layout
          showInNavigation
          icon
          id
          createdAt
          updatedAt
          workspaceDashboardsId
          dashboardGroupDashboardsId
          dashboardDashboardGroupId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWorkspace = /* GraphQL */ `
  mutation DeleteWorkspace(
    $input: DeleteWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    deleteWorkspace(input: $input, condition: $condition) {
      id
      workspaceGroups
      name
      logoLink
      workspacetoken
      networks {
        items {
          workspaceGroups
          networkOrgName
          orgId
          api_key
          api_secret
          id
          createdAt
          updatedAt
          workspaceNetworksId
          networkTypeNetworksId
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      objectProperties {
        items {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectPropertiesId
          __typename
        }
        nextToken
        __typename
      }
      objectTypes {
        items {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectTypesId
          __typename
        }
        nextToken
        __typename
      }
      sites {
        items {
          workspaceGroups
          name
          metadata
          address
          zip_code
          city
          subRegion
          region
          country
          AWSLocationLabel
          AWSLongLat
          properties
          id
          createdAt
          updatedAt
          workspaceSitesId
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          workspaceGroups
          name
          layout
          showInNavigation
          icon
          id
          createdAt
          updatedAt
          workspaceDashboardsId
          dashboardGroupDashboardsId
          dashboardDashboardGroupId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNetworkType = /* GraphQL */ `
  mutation CreateNetworkType(
    $input: CreateNetworkTypeInput!
    $condition: ModelNetworkTypeConditionInput
  ) {
    createNetworkType(input: $input, condition: $condition) {
      name
      identifier
      description
      logoLink
      networks {
        items {
          workspaceGroups
          networkOrgName
          orgId
          api_key
          api_secret
          id
          createdAt
          updatedAt
          workspaceNetworksId
          networkTypeNetworksId
          __typename
        }
        nextToken
        __typename
      }
      apiEndpoint
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNetworkType = /* GraphQL */ `
  mutation UpdateNetworkType(
    $input: UpdateNetworkTypeInput!
    $condition: ModelNetworkTypeConditionInput
  ) {
    updateNetworkType(input: $input, condition: $condition) {
      name
      identifier
      description
      logoLink
      networks {
        items {
          workspaceGroups
          networkOrgName
          orgId
          api_key
          api_secret
          id
          createdAt
          updatedAt
          workspaceNetworksId
          networkTypeNetworksId
          __typename
        }
        nextToken
        __typename
      }
      apiEndpoint
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNetworkType = /* GraphQL */ `
  mutation DeleteNetworkType(
    $input: DeleteNetworkTypeInput!
    $condition: ModelNetworkTypeConditionInput
  ) {
    deleteNetworkType(input: $input, condition: $condition) {
      name
      identifier
      description
      logoLink
      networks {
        items {
          workspaceGroups
          networkOrgName
          orgId
          api_key
          api_secret
          id
          createdAt
          updatedAt
          workspaceNetworksId
          networkTypeNetworksId
          __typename
        }
        nextToken
        __typename
      }
      apiEndpoint
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNetwork = /* GraphQL */ `
  mutation CreateNetwork(
    $input: CreateNetworkInput!
    $condition: ModelNetworkConditionInput
  ) {
    createNetwork(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      networkOrgName
      networkType {
        name
        identifier
        description
        logoLink
        networks {
          nextToken
          __typename
        }
        apiEndpoint
        id
        createdAt
        updatedAt
        __typename
      }
      orgId
      api_key
      api_secret
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceNetworksId
      networkTypeNetworksId
      __typename
    }
  }
`;
export const updateNetwork = /* GraphQL */ `
  mutation UpdateNetwork(
    $input: UpdateNetworkInput!
    $condition: ModelNetworkConditionInput
  ) {
    updateNetwork(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      networkOrgName
      networkType {
        name
        identifier
        description
        logoLink
        networks {
          nextToken
          __typename
        }
        apiEndpoint
        id
        createdAt
        updatedAt
        __typename
      }
      orgId
      api_key
      api_secret
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceNetworksId
      networkTypeNetworksId
      __typename
    }
  }
`;
export const deleteNetwork = /* GraphQL */ `
  mutation DeleteNetwork(
    $input: DeleteNetworkInput!
    $condition: ModelNetworkConditionInput
  ) {
    deleteNetwork(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      networkOrgName
      networkType {
        name
        identifier
        description
        logoLink
        networks {
          nextToken
          __typename
        }
        apiEndpoint
        id
        createdAt
        updatedAt
        __typename
      }
      orgId
      api_key
      api_secret
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceNetworksId
      networkTypeNetworksId
      __typename
    }
  }
`;
export const createDashboard = /* GraphQL */ `
  mutation CreateDashboard(
    $input: CreateDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    createDashboard(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      layout
      showInNavigation
      icon
      dashboardGroup {
        workspace
        name
        dashboards {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceDashboardsId
      dashboardGroupDashboardsId
      dashboardDashboardGroupId
      __typename
    }
  }
`;
export const updateDashboard = /* GraphQL */ `
  mutation UpdateDashboard(
    $input: UpdateDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    updateDashboard(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      layout
      showInNavigation
      icon
      dashboardGroup {
        workspace
        name
        dashboards {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceDashboardsId
      dashboardGroupDashboardsId
      dashboardDashboardGroupId
      __typename
    }
  }
`;
export const deleteDashboard = /* GraphQL */ `
  mutation DeleteDashboard(
    $input: DeleteDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    deleteDashboard(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      layout
      showInNavigation
      icon
      dashboardGroup {
        workspace
        name
        dashboards {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceDashboardsId
      dashboardGroupDashboardsId
      dashboardDashboardGroupId
      __typename
    }
  }
`;
export const createDashboardPanel = /* GraphQL */ `
  mutation CreateDashboardPanel(
    $input: CreateDashboardPanelInput!
    $condition: ModelDashboardPanelConditionInput
  ) {
    createDashboardPanel(input: $input, condition: $condition) {
      name
      type
      minWidth
      minHeight
      maxWidth
      maxHeight
      dashboard {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        layout
        showInNavigation
        icon
        dashboardGroup {
          workspace
          name
          id
          createdAt
          updatedAt
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceDashboardsId
        dashboardGroupDashboardsId
        dashboardDashboardGroupId
        __typename
      }
      id
      createdAt
      updatedAt
      dashboardPanelDashboardId
      __typename
    }
  }
`;
export const updateDashboardPanel = /* GraphQL */ `
  mutation UpdateDashboardPanel(
    $input: UpdateDashboardPanelInput!
    $condition: ModelDashboardPanelConditionInput
  ) {
    updateDashboardPanel(input: $input, condition: $condition) {
      name
      type
      minWidth
      minHeight
      maxWidth
      maxHeight
      dashboard {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        layout
        showInNavigation
        icon
        dashboardGroup {
          workspace
          name
          id
          createdAt
          updatedAt
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceDashboardsId
        dashboardGroupDashboardsId
        dashboardDashboardGroupId
        __typename
      }
      id
      createdAt
      updatedAt
      dashboardPanelDashboardId
      __typename
    }
  }
`;
export const deleteDashboardPanel = /* GraphQL */ `
  mutation DeleteDashboardPanel(
    $input: DeleteDashboardPanelInput!
    $condition: ModelDashboardPanelConditionInput
  ) {
    deleteDashboardPanel(input: $input, condition: $condition) {
      name
      type
      minWidth
      minHeight
      maxWidth
      maxHeight
      dashboard {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        layout
        showInNavigation
        icon
        dashboardGroup {
          workspace
          name
          id
          createdAt
          updatedAt
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceDashboardsId
        dashboardGroupDashboardsId
        dashboardDashboardGroupId
        __typename
      }
      id
      createdAt
      updatedAt
      dashboardPanelDashboardId
      __typename
    }
  }
`;
export const createDashboardGroup = /* GraphQL */ `
  mutation CreateDashboardGroup(
    $input: CreateDashboardGroupInput!
    $condition: ModelDashboardGroupConditionInput
  ) {
    createDashboardGroup(input: $input, condition: $condition) {
      workspace
      name
      dashboards {
        items {
          workspaceGroups
          name
          layout
          showInNavigation
          icon
          id
          createdAt
          updatedAt
          workspaceDashboardsId
          dashboardGroupDashboardsId
          dashboardDashboardGroupId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDashboardGroup = /* GraphQL */ `
  mutation UpdateDashboardGroup(
    $input: UpdateDashboardGroupInput!
    $condition: ModelDashboardGroupConditionInput
  ) {
    updateDashboardGroup(input: $input, condition: $condition) {
      workspace
      name
      dashboards {
        items {
          workspaceGroups
          name
          layout
          showInNavigation
          icon
          id
          createdAt
          updatedAt
          workspaceDashboardsId
          dashboardGroupDashboardsId
          dashboardDashboardGroupId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDashboardGroup = /* GraphQL */ `
  mutation DeleteDashboardGroup(
    $input: DeleteDashboardGroupInput!
    $condition: ModelDashboardGroupConditionInput
  ) {
    deleteDashboardGroup(input: $input, condition: $condition) {
      workspace
      name
      dashboards {
        items {
          workspaceGroups
          name
          layout
          showInNavigation
          icon
          id
          createdAt
          updatedAt
          workspaceDashboardsId
          dashboardGroupDashboardsId
          dashboardDashboardGroupId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSite = /* GraphQL */ `
  mutation CreateSite(
    $input: CreateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    createSite(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      metadata
      address
      zip_code
      city
      subRegion
      region
      country
      AWSLocationLabel
      AWSLongLat
      properties
      id
      createdAt
      updatedAt
      workspaceSitesId
      __typename
    }
  }
`;
export const updateSite = /* GraphQL */ `
  mutation UpdateSite(
    $input: UpdateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    updateSite(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      metadata
      address
      zip_code
      city
      subRegion
      region
      country
      AWSLocationLabel
      AWSLongLat
      properties
      id
      createdAt
      updatedAt
      workspaceSitesId
      __typename
    }
  }
`;
export const deleteSite = /* GraphQL */ `
  mutation DeleteSite(
    $input: DeleteSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    deleteSite(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      metadata
      address
      zip_code
      city
      subRegion
      region
      country
      AWSLocationLabel
      AWSLongLat
      properties
      id
      createdAt
      updatedAt
      workspaceSitesId
      __typename
    }
  }
`;
export const createSiteProperty = /* GraphQL */ `
  mutation CreateSiteProperty(
    $input: CreateSitePropertyInput!
    $condition: ModelSitePropertyConditionInput
  ) {
    createSiteProperty(input: $input, condition: $condition) {
      workspace
      name
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSiteProperty = /* GraphQL */ `
  mutation UpdateSiteProperty(
    $input: UpdateSitePropertyInput!
    $condition: ModelSitePropertyConditionInput
  ) {
    updateSiteProperty(input: $input, condition: $condition) {
      workspace
      name
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSiteProperty = /* GraphQL */ `
  mutation DeleteSiteProperty(
    $input: DeleteSitePropertyInput!
    $condition: ModelSitePropertyConditionInput
  ) {
    deleteSiteProperty(input: $input, condition: $condition) {
      workspace
      name
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createObject = /* GraphQL */ `
  mutation CreateObject(
    $input: CreateObjectInput!
    $condition: ModelObjectConditionInput
  ) {
    createObject(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      type {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceObjectTypesId
        __typename
      }
      manufacturerSerialNumber
      manufacturer
      model
      modelNumber
      properties
      site {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        properties
        id
        createdAt
        updatedAt
        workspaceSitesId
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceObjectsId
      siteObjectsId
      objectTypeObjectsId
      __typename
    }
  }
`;
export const updateObject = /* GraphQL */ `
  mutation UpdateObject(
    $input: UpdateObjectInput!
    $condition: ModelObjectConditionInput
  ) {
    updateObject(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      type {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceObjectTypesId
        __typename
      }
      manufacturerSerialNumber
      manufacturer
      model
      modelNumber
      properties
      site {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        properties
        id
        createdAt
        updatedAt
        workspaceSitesId
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceObjectsId
      siteObjectsId
      objectTypeObjectsId
      __typename
    }
  }
`;
export const deleteObject = /* GraphQL */ `
  mutation DeleteObject(
    $input: DeleteObjectInput!
    $condition: ModelObjectConditionInput
  ) {
    deleteObject(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      type {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceObjectTypesId
        __typename
      }
      manufacturerSerialNumber
      manufacturer
      model
      modelNumber
      properties
      site {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        properties
        id
        createdAt
        updatedAt
        workspaceSitesId
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceObjectsId
      siteObjectsId
      objectTypeObjectsId
      __typename
    }
  }
`;
export const createObjectProperty = /* GraphQL */ `
  mutation CreateObjectProperty(
    $input: CreateObjectPropertyInput!
    $condition: ModelObjectPropertyConditionInput
  ) {
    createObjectProperty(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      id
      createdAt
      updatedAt
      workspaceObjectPropertiesId
      __typename
    }
  }
`;
export const updateObjectProperty = /* GraphQL */ `
  mutation UpdateObjectProperty(
    $input: UpdateObjectPropertyInput!
    $condition: ModelObjectPropertyConditionInput
  ) {
    updateObjectProperty(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      id
      createdAt
      updatedAt
      workspaceObjectPropertiesId
      __typename
    }
  }
`;
export const deleteObjectProperty = /* GraphQL */ `
  mutation DeleteObjectProperty(
    $input: DeleteObjectPropertyInput!
    $condition: ModelObjectPropertyConditionInput
  ) {
    deleteObjectProperty(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      id
      createdAt
      updatedAt
      workspaceObjectPropertiesId
      __typename
    }
  }
`;
export const createObjectType = /* GraphQL */ `
  mutation CreateObjectType(
    $input: CreateObjectTypeInput!
    $condition: ModelObjectTypeConditionInput
  ) {
    createObjectType(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceObjectTypesId
      __typename
    }
  }
`;
export const updateObjectType = /* GraphQL */ `
  mutation UpdateObjectType(
    $input: UpdateObjectTypeInput!
    $condition: ModelObjectTypeConditionInput
  ) {
    updateObjectType(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceObjectTypesId
      __typename
    }
  }
`;
export const deleteObjectType = /* GraphQL */ `
  mutation DeleteObjectType(
    $input: DeleteObjectTypeInput!
    $condition: ModelObjectTypeConditionInput
  ) {
    deleteObjectType(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      objects {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          manufacturer
          model
          modelNumber
          properties
          id
          createdAt
          updatedAt
          workspaceObjectsId
          siteObjectsId
          objectTypeObjectsId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceObjectTypesId
      __typename
    }
  }
`;
export const createDevice = /* GraphQL */ `
  mutation CreateDevice(
    $input: CreateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    createDevice(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      manufacturerSerialNumber
      app_eui
      app_key
      dev_eui
      deviceModel {
        name
        modelNumber
        type
        deviceManufacturer {
          name
          imgLink
          id
          createdAt
          updatedAt
          __typename
        }
        imgLink
        decoderLink
        sensors {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        deviceManufacturerDeviceModelsId
        __typename
      }
      site {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        properties
        id
        createdAt
        updatedAt
        workspaceSitesId
        __typename
      }
      object {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        type {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectTypesId
          __typename
        }
        manufacturerSerialNumber
        manufacturer
        model
        modelNumber
        properties
        site {
          workspaceGroups
          name
          metadata
          address
          zip_code
          city
          subRegion
          region
          country
          AWSLocationLabel
          AWSLongLat
          properties
          id
          createdAt
          updatedAt
          workspaceSitesId
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceObjectsId
        siteObjectsId
        objectTypeObjectsId
        __typename
      }
      positionOnObject
      network {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        networkOrgName
        networkType {
          name
          identifier
          description
          logoLink
          apiEndpoint
          id
          createdAt
          updatedAt
          __typename
        }
        orgId
        api_key
        api_secret
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceNetworksId
        networkTypeNetworksId
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceDevicesId
      networkDevicesId
      siteDevicesId
      objectDevicesId
      deviceModelDevicesId
      __typename
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice(
    $input: UpdateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    updateDevice(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      manufacturerSerialNumber
      app_eui
      app_key
      dev_eui
      deviceModel {
        name
        modelNumber
        type
        deviceManufacturer {
          name
          imgLink
          id
          createdAt
          updatedAt
          __typename
        }
        imgLink
        decoderLink
        sensors {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        deviceManufacturerDeviceModelsId
        __typename
      }
      site {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        properties
        id
        createdAt
        updatedAt
        workspaceSitesId
        __typename
      }
      object {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        type {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectTypesId
          __typename
        }
        manufacturerSerialNumber
        manufacturer
        model
        modelNumber
        properties
        site {
          workspaceGroups
          name
          metadata
          address
          zip_code
          city
          subRegion
          region
          country
          AWSLocationLabel
          AWSLongLat
          properties
          id
          createdAt
          updatedAt
          workspaceSitesId
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceObjectsId
        siteObjectsId
        objectTypeObjectsId
        __typename
      }
      positionOnObject
      network {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        networkOrgName
        networkType {
          name
          identifier
          description
          logoLink
          apiEndpoint
          id
          createdAt
          updatedAt
          __typename
        }
        orgId
        api_key
        api_secret
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceNetworksId
        networkTypeNetworksId
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceDevicesId
      networkDevicesId
      siteDevicesId
      objectDevicesId
      deviceModelDevicesId
      __typename
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice(
    $input: DeleteDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    deleteDevice(input: $input, condition: $condition) {
      workspace {
        id
        workspaceGroups
        name
        logoLink
        workspacetoken
        networks {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        objects {
          nextToken
          __typename
        }
        objectProperties {
          nextToken
          __typename
        }
        objectTypes {
          nextToken
          __typename
        }
        sites {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      workspaceGroups
      name
      manufacturerSerialNumber
      app_eui
      app_key
      dev_eui
      deviceModel {
        name
        modelNumber
        type
        deviceManufacturer {
          name
          imgLink
          id
          createdAt
          updatedAt
          __typename
        }
        imgLink
        decoderLink
        sensors {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        deviceManufacturerDeviceModelsId
        __typename
      }
      site {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        objects {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        properties
        id
        createdAt
        updatedAt
        workspaceSitesId
        __typename
      }
      object {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        name
        type {
          workspaceGroups
          name
          id
          createdAt
          updatedAt
          workspaceObjectTypesId
          __typename
        }
        manufacturerSerialNumber
        manufacturer
        model
        modelNumber
        properties
        site {
          workspaceGroups
          name
          metadata
          address
          zip_code
          city
          subRegion
          region
          country
          AWSLocationLabel
          AWSLongLat
          properties
          id
          createdAt
          updatedAt
          workspaceSitesId
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceObjectsId
        siteObjectsId
        objectTypeObjectsId
        __typename
      }
      positionOnObject
      network {
        workspace {
          id
          workspaceGroups
          name
          logoLink
          workspacetoken
          createdAt
          updatedAt
          __typename
        }
        workspaceGroups
        networkOrgName
        networkType {
          name
          identifier
          description
          logoLink
          apiEndpoint
          id
          createdAt
          updatedAt
          __typename
        }
        orgId
        api_key
        api_secret
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        workspaceNetworksId
        networkTypeNetworksId
        __typename
      }
      id
      createdAt
      updatedAt
      workspaceDevicesId
      networkDevicesId
      siteDevicesId
      objectDevicesId
      deviceModelDevicesId
      __typename
    }
  }
`;
export const createDeviceManufacturer = /* GraphQL */ `
  mutation CreateDeviceManufacturer(
    $input: CreateDeviceManufacturerInput!
    $condition: ModelDeviceManufacturerConditionInput
  ) {
    createDeviceManufacturer(input: $input, condition: $condition) {
      name
      imgLink
      deviceModels {
        items {
          name
          modelNumber
          type
          imgLink
          decoderLink
          id
          createdAt
          updatedAt
          deviceManufacturerDeviceModelsId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeviceManufacturer = /* GraphQL */ `
  mutation UpdateDeviceManufacturer(
    $input: UpdateDeviceManufacturerInput!
    $condition: ModelDeviceManufacturerConditionInput
  ) {
    updateDeviceManufacturer(input: $input, condition: $condition) {
      name
      imgLink
      deviceModels {
        items {
          name
          modelNumber
          type
          imgLink
          decoderLink
          id
          createdAt
          updatedAt
          deviceManufacturerDeviceModelsId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeviceManufacturer = /* GraphQL */ `
  mutation DeleteDeviceManufacturer(
    $input: DeleteDeviceManufacturerInput!
    $condition: ModelDeviceManufacturerConditionInput
  ) {
    deleteDeviceManufacturer(input: $input, condition: $condition) {
      name
      imgLink
      deviceModels {
        items {
          name
          modelNumber
          type
          imgLink
          decoderLink
          id
          createdAt
          updatedAt
          deviceManufacturerDeviceModelsId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeviceModel = /* GraphQL */ `
  mutation CreateDeviceModel(
    $input: CreateDeviceModelInput!
    $condition: ModelDeviceModelConditionInput
  ) {
    createDeviceModel(input: $input, condition: $condition) {
      name
      modelNumber
      type
      deviceManufacturer {
        name
        imgLink
        deviceModels {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      imgLink
      decoderLink
      sensors {
        items {
          id
          deviceModelID
          sensorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      deviceManufacturerDeviceModelsId
      __typename
    }
  }
`;
export const updateDeviceModel = /* GraphQL */ `
  mutation UpdateDeviceModel(
    $input: UpdateDeviceModelInput!
    $condition: ModelDeviceModelConditionInput
  ) {
    updateDeviceModel(input: $input, condition: $condition) {
      name
      modelNumber
      type
      deviceManufacturer {
        name
        imgLink
        deviceModels {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      imgLink
      decoderLink
      sensors {
        items {
          id
          deviceModelID
          sensorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      deviceManufacturerDeviceModelsId
      __typename
    }
  }
`;
export const deleteDeviceModel = /* GraphQL */ `
  mutation DeleteDeviceModel(
    $input: DeleteDeviceModelInput!
    $condition: ModelDeviceModelConditionInput
  ) {
    deleteDeviceModel(input: $input, condition: $condition) {
      name
      modelNumber
      type
      deviceManufacturer {
        name
        imgLink
        deviceModels {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      imgLink
      decoderLink
      sensors {
        items {
          id
          deviceModelID
          sensorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          workspaceGroups
          name
          manufacturerSerialNumber
          app_eui
          app_key
          dev_eui
          positionOnObject
          id
          createdAt
          updatedAt
          workspaceDevicesId
          networkDevicesId
          siteDevicesId
          objectDevicesId
          deviceModelDevicesId
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      deviceManufacturerDeviceModelsId
      __typename
    }
  }
`;
export const createSensor = /* GraphQL */ `
  mutation CreateSensor(
    $input: CreateSensorInput!
    $condition: ModelSensorConditionInput
  ) {
    createSensor(input: $input, condition: $condition) {
      name
      identifier
      dimension
      type
      unit
      description
      deviceModels {
        items {
          id
          deviceModelID
          sensorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSensor = /* GraphQL */ `
  mutation UpdateSensor(
    $input: UpdateSensorInput!
    $condition: ModelSensorConditionInput
  ) {
    updateSensor(input: $input, condition: $condition) {
      name
      identifier
      dimension
      type
      unit
      description
      deviceModels {
        items {
          id
          deviceModelID
          sensorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSensor = /* GraphQL */ `
  mutation DeleteSensor(
    $input: DeleteSensorInput!
    $condition: ModelSensorConditionInput
  ) {
    deleteSensor(input: $input, condition: $condition) {
      name
      identifier
      dimension
      type
      unit
      description
      deviceModels {
        items {
          id
          deviceModelID
          sensorID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeviceModelSensors = /* GraphQL */ `
  mutation CreateDeviceModelSensors(
    $input: CreateDeviceModelSensorsInput!
    $condition: ModelDeviceModelSensorsConditionInput
  ) {
    createDeviceModelSensors(input: $input, condition: $condition) {
      id
      deviceModelID
      sensorID
      deviceModel {
        name
        modelNumber
        type
        deviceManufacturer {
          name
          imgLink
          id
          createdAt
          updatedAt
          __typename
        }
        imgLink
        decoderLink
        sensors {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        deviceManufacturerDeviceModelsId
        __typename
      }
      sensor {
        name
        identifier
        dimension
        type
        unit
        description
        deviceModels {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeviceModelSensors = /* GraphQL */ `
  mutation UpdateDeviceModelSensors(
    $input: UpdateDeviceModelSensorsInput!
    $condition: ModelDeviceModelSensorsConditionInput
  ) {
    updateDeviceModelSensors(input: $input, condition: $condition) {
      id
      deviceModelID
      sensorID
      deviceModel {
        name
        modelNumber
        type
        deviceManufacturer {
          name
          imgLink
          id
          createdAt
          updatedAt
          __typename
        }
        imgLink
        decoderLink
        sensors {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        deviceManufacturerDeviceModelsId
        __typename
      }
      sensor {
        name
        identifier
        dimension
        type
        unit
        description
        deviceModels {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeviceModelSensors = /* GraphQL */ `
  mutation DeleteDeviceModelSensors(
    $input: DeleteDeviceModelSensorsInput!
    $condition: ModelDeviceModelSensorsConditionInput
  ) {
    deleteDeviceModelSensors(input: $input, condition: $condition) {
      id
      deviceModelID
      sensorID
      deviceModel {
        name
        modelNumber
        type
        deviceManufacturer {
          name
          imgLink
          id
          createdAt
          updatedAt
          __typename
        }
        imgLink
        decoderLink
        sensors {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        deviceManufacturerDeviceModelsId
        __typename
      }
      sensor {
        name
        identifier
        dimension
        type
        unit
        description
        deviceModels {
          nextToken
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
